import { PrepaidCardImageRow } from '@models/prepaidCard';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface PpCardListContextProps {
    data: PrepaidCardImageRow;
    type: 'GIFT' | 'BUY';
    giftItemId?: string;
    indicator:number;
    setIndicator: Dispatch<SetStateAction<number>>;
    sliderIndex: number;
    setSliderIndex: Dispatch<SetStateAction<number>>;
    swiper?: any;
    setSwiper: Dispatch<SetStateAction<any>>;
}

const PpCardListContext = createContext<PpCardListContextProps>({} as PpCardListContextProps);

export default PpCardListContext;
